var baseDatepickerOpts = {
    locale: 'ja',
    dayViewHeaderFormat: 'YYYY年 M月',
    format: 'YYYY/MM/DD',
};

$(() => {
    $('#preferred_start_date').datetimepicker(baseDatepickerOpts);
});
